<template>
  <div class="mb-8">
    <h3 class="text-2xl font-semibold leading-6 text-gray-900 mb-4">
      Getting Started
    </h3>

    <p>
      Getting started with Rail Ops is easy. We created a Collection for you automatically when you created your account.
      Now, you can add your roster in three ways:
    </p>

    <ul class="my-4 list-disc list-inside space-y-3">
      <li>
        Set up the Rail Ops Sync with JMRI.
        <a href="https://railops.app/docs/jmri/install" target="_blank">Follow these instructions</a> to get started.
      </li>
      <li>
        Import your roster from CSV files.
        <a href="https://railops.app/docs/roster/csv-import" target="_blank">
          Read more.
        </a>
      </li>
      <li>
        Add items manually from the <router-link :to="{ name: 'locomotives.list' }">Locomotives</router-link> or
        <router-link :to="{ name: 'cars.list' }">Cars</router-link> pages.
      </li>
    </ul>
  </div>

</template>

<style lang="scss" scoped>
a {
  @apply text-brand-dark underline underline-offset-2;

  &:hover {
    @apply no-underline;
  }
}

</style>
